import React from 'react';
import {Box, BoxProps, Flex} from '@chakra-ui/react';

const PageTitle = ({children, ...props}: BoxProps) => {
  return (
    <Box fontSize="2xl" fontWeight={500} {...props}>
      {children}
    </Box>
  );
};

export const PageHeader = ({
  children,
  title,
  ...props
}: BoxProps & {
  title: string;
}) => {
  return (
    <Flex
      alignItems="center"
      bgColor="kgray.100"
      h={20}
      justifyContent="space-between"
      p={4}
      {...props}
    >
      <PageTitle>{title}</PageTitle>
      {children}
    </Flex>
  );
};
